import { createWebSupportChatWindowEventFactory } from '@spotify-internal/ubi-sdk-support-spotify-com-web-support-chat-window';
import { useEffect, useMemo } from 'react';

import { registerLpChatEventListeners } from 'lib/client/liveEngage/chatEvents';

import { useUbiContext } from '../ubiProvider';

interface RootParameters {
  data: {
    identifier: string;
    uri: string;
  };
}

export const useUbiChatWindow = (rootParams: RootParameters) => {
  const ubiLogger = useUbiContext();
  const pageFactory = useMemo(() => createWebSupportChatWindowEventFactory(rootParams), [rootParams]);

  useEffect(() => {
    registerLpChatEventListeners({
      botMessageEventListener: by =>
        ubiLogger.logImpression(pageFactory.botMessageFactory({ identifier: by }).impression()),
      botOptionsPresentedEventListener: (by, title, position) =>
        ubiLogger.logImpression(
          pageFactory
            .botMessageFactory({ identifier: by })
            .botQuickReplyFactory({
              identifier: title,
              position,
            })
            .impression(),
        ),
      botOptionSelectedEventListener: (by, identifier, position) =>
        ubiLogger.logInteraction(
          pageFactory
            .botMessageFactory({ identifier: by })
            .botQuickReplyFactory({
              identifier,
              position,
            })
            .hitPickQuickReply(),
        ),
      advisorMessageEventListener: (by: string) =>
        ubiLogger.logImpression(pageFactory.advisorMessageFactory({ identifier: by }).impression()),
      customerMessageEventListener: () =>
        ubiLogger.logInteraction(pageFactory.customerMessageFactory().hitSendMessage()),
    });
  }, [ubiLogger, pageFactory]);
};
